export enum AuthorityFunctionName {
  RECORD_EXPIRATION_EVENT_HANDLER = 'recordExpirationEventHandler',
}
